const dev = {
  API_URL: "http://127.0.0.1:5000",
  API_KEY: "OGXDVwlBcFBGZ4NYzjH8aipE8k2Lgz14clBlz20h",
};

const stage = {
  API_URL: "https://localhost:8080",
  API_KEY: "OGXDVwlBcFBGZ4NYzjH8aipE8k2Lgz14clBlz20h",
};

const prod = {
  API_URL: "https://t6sxcqpdr1.execute-api.ap-southeast-1.amazonaws.com/prod",
  API_KEY: "OGXDVwlBcFBGZ4NYzjH8aipE8k2Lgz14clBlz20h",
};

const config =
  process.env.REACT_APP_ENV === "PROD"
    ? prod
    : process.env.REACT_APP_ENV === "STAGE"
    ? stage
    : dev;

export default {
  ...config,
};
